import { render, staticRenderFns } from "./passwordReset.vue?vue&type=template&id=6b287d50&scoped=true&"
import script from "./passwordReset.vue?vue&type=script&lang=js&"
export * from "./passwordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b287d50",
  null
  
)

export default component.exports